import React from "react";
import PageTitle from "../../layout/PageTitle";
import {Container} from "react-bootstrap";

const TermsAndConditions = () => {
  return (
    <Container>
      <PageTitle title='Termeni și condiții'/>
      <p>
        Bun venit la website-ul nostru! Accesând și folosind acest website, sunteți de acord să respectați și să fiți
        legat de următorii termeni și condiții de utilizare. Vă rugăm să citiți cu atenție aceste reguli înainte de a
        continua să utilizați website-ul.
      </p>

      <h5>Utilizarea website-ului</h5>
      <ul>
        <li>
          Acest website este destinat utilizării personale și non-comerciale. Nu aveți voie să utilizați acest website
          în niciun mod care ar putea afecta sau împiedica funcționarea sa normală.
        </li>
        <li>
          Vă angajați să nu utilizați acest website în scopuri ilegale sau interzise de acești termeni și condiții.
        </li>
      </ul>

      <h5>Confidențialitate și protecția datelor</h5>
      <ul>
        <li>
          Colectăm și prelucrăm datele dvs. personale în conformitate cu politica noastră de confidențialitate. Prin
          utilizarea acestui website, sunteți de acord cu colectarea și utilizarea datelor dvs. conform acestei
          politici.
        </li>
      </ul>

      <h5>Drepturi de autor și proprietate intelectuală</h5>
      <ul>
        <li>
          Conținutul acestui website, inclusiv textele, imaginile și alte materiale, sunt protejate de drepturile de
          autor și alte legi referitoare la proprietatea intelectuală. Nu aveți voie să copiați, să distribuiți sau să
          modificați conținutul acestui website fără permisiunea noastră prealabilă.
        </li>
      </ul>

      <h5>Limitări și excluderi de răspundere</h5>
      <ul>
        <li>
          Utilizați acest website pe propriul dvs. risc. Nu garantăm că acesta va fi întotdeauna disponibil sau că
          informațiile furnizate sunt complete, exacte sau actualizate.
        </li>
        <li>
          Nu ne asumăm nicio răspundere pentru orice prejudicii sau pierderi suferite de dvs. în legătură cu utilizarea
          acestui website.
        </li>
      </ul>

      <h5>Modificări ale termenilor și condițiilor</h5>
      <ul>
        <li>
          Ne rezervăm dreptul de a modifica acești termeni și condiții în orice moment fără notificare prealabilă. Este
          responsabilitatea dvs. să verificați periodic această pagină pentru a fi la curent cu eventualele modificări.
        </li>
      </ul>

      <h5>Legislație aplicabilă și jurisdicție</h5>
      <ul>
        <li>
          Acești termeni și condiții sunt guvernați de legile statului nostru și orice litigiu care ar putea să apară în
          legătură cu acești termeni și condiții va fi supus jurisdicției exclusive a instanțelor competente din acest
          stat.
        </li>
      </ul>
      <p>
        Prin accesarea și utilizarea acestui website, confirmați că ați citit, înțeles și că sunteți de acord cu acești
        termeni și condiții. Dacă nu sunteți de acord cu oricare dintre acești termeni, vă rugăm să nu utilizați acest
        website.
      </p>

      <p className="text-decoration-underline fst-italic">Data ultimei actualizări: 20 Feb 2024</p>
    </Container>
  )
};

export default TermsAndConditions;